import { ICreateGroup } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import { CreateGroupPayload } from "@grassrootly/api/gateways";
import server from "../Server";
import moment from "moment";

export const CreateGroup = async (payload: CreateGroupPayload): Promise<Partial<ICreateGroup[]>> => {
  const createGroup: Partial<ICreateGroup[]> = [];

  for (let i = 0; i < payload.createGroup.length; i++) {
    const inserted = withErrorCheck(
      await server
        .from("Groups")
        .insert({
          name: payload.createGroup[i].name,
          group_logo: payload.createGroup[i].group_logo,
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        })
        .select()
    )[0];
    createGroup.push(inserted);
  }

  return createGroup;
};
